import { usePlanningStore } from '@/stores/planning';

/**
 * A planning message that asks the user to do something (e.g. tick interventie
 * on the fase by hand). Unlike the error toast it never auto-dismisses: it stays
 * until the user closes it. Sits above the error toast so both can show.
 */
export function PlanningWarningToast() {
  const warning = usePlanningStore((s) => s.warning);
  const clearWarning = usePlanningStore((s) => s.clearWarning);
  if (!warning) return null;
  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-50 max-w-md bg-orange-600 text-white px-5 py-3 rounded-xl shadow-xl flex items-center gap-3 animate-in" role="alert">
      <span className="text-sm font-semibold">{warning}</span>
      <button type="button" onClick={clearWarning} className="p-0.5 hover:bg-white/20 rounded" aria-label="Sluiten">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
      </button>
    </div>
  );
}
